'use strict';

import {gsap} from "gsap";

const init = () => {
    const toTop = document.getElementById('to-top');

    if (toTop) {
        window.addEventListener('scroll', function () {
            const topOfContainer = document.getElementById('main-container').offsetTop;

            if (window.scrollY > topOfContainer + 100) {
                toTop.classList.add('active');
            } else {
                toTop.classList.remove('active');
            }
        });

        toTop.addEventListener('click', () => {
            gsap.to(window, {duration: .5, scrollTo: 0});
        });
    }
}

export default {init};
